/**
 * Resuelve logo y nombre a mostrar en NavBar.
 * Prioridad: datos SGR del tenant (multitenant) → branding CloudFront/theme del cliente → null (fallback Movil en UI).
 */
export type NavbarBrandingInput = {
  sgrLogo?: string | null;
  sgrName?: string | null;
  clientLogoUrl?: string | null;
  clientThemeName?: string | null;
  /** When true, client CloudFront logo wins over tenant SGR logo (ACA env). */
  preferClientBranding?: boolean;
};

export type NavbarBranding = {
  logoUrl: string | null;
  displayName: string | null;
};

export function resolveNavbarBranding({
  sgrLogo,
  sgrName,
  clientLogoUrl,
  clientThemeName,
  preferClientBranding = false,
}: NavbarBrandingInput): NavbarBranding {
  const logoUrl = preferClientBranding
    ? clientLogoUrl || sgrLogo || null
    : sgrLogo || clientLogoUrl || null;
  const displayName = sgrName || clientThemeName || null;
  return { logoUrl, displayName };
}
